import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const DISCORD_INVITE_URL = "https://discord.gg/XnE5VQehxr";

const navLinkClass = "whitespace-nowrap text-[9px] uppercase tracking-[0.18em] text-[#A1A1AA] transition-colors duration-300 hover:text-[#62C7D2]";

export default function Navbar({ onAccess }) {
  const { user } = useAuth();

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="relative z-50 border-b border-white/10 bg-black/80 pt-[env(safe-area-inset-top)] backdrop-blur-xl md:fixed md:left-0 md:right-0 md:top-0 md:pt-0"
      data-testid="main-navbar"
    >
      <div className="mx-auto flex h-16 max-w-[1500px] items-center justify-between gap-3 px-4 sm:px-7 lg:px-12">
        <a href="#top" className="flex shrink-0 items-center gap-2.5" data-testid="nav-logo">
          <span className="raava-logo-glow flex h-8 w-8 items-center justify-center">
            <img src="/raava-logo-blue.png" alt="" className="h-8 w-8 object-contain" />
          </span>
          <span className="font-display text-xs tracking-[0.17em] text-[#F4F4F5] sm:text-sm" style={{ fontWeight: 700 }}>RAAVA</span>
        </a>

        <nav className="hidden min-w-0 items-center gap-4 md:flex lg:gap-7" aria-label="Main navigation">
          <a href="#top" className={navLinkClass} data-testid="nav-start-link">Start</a>
          <a href="#manifest" className={navLinkClass} data-testid="nav-manifest-link">About</a>
          <a href="#features" className={navLinkClass} data-testid="nav-features-link">Projects</a>
          <a href="#access" className={navLinkClass} data-testid="nav-access-link">Account</a>
          {user && <Link to="/changelog" className={navLinkClass} data-testid="nav-changelog-link">Changelog</Link>}
        </nav>

        <div className="flex shrink-0 items-center gap-2">
          <a
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noreferrer"
            className="group flex h-10 items-center gap-2 rounded-xl border border-[#5865F2]/35 bg-[#5865F2]/[0.08] px-3 text-[9px] uppercase tracking-[0.13em] text-[#B8BEFF] transition-all duration-300 hover:border-[#7B84FF]/65 hover:bg-[#5865F2]/15 hover:text-white"
            data-testid="nav-discord-link"
          >
            <img src="/discord-logo-transparent.png" alt="" className="h-[19px] w-[19px] object-contain" />
            <span className="hidden sm:inline">Join Discord</span>
          </a>

          {user ? (
            <Link
              to="/profile"
              className="flex h-10 items-center rounded-xl border border-[#258DFF]/70 px-3.5 text-[9px] uppercase tracking-[0.16em] text-[#7FC8FF] transition-colors duration-300 hover:bg-[#147DFF] hover:text-white sm:px-4"
              data-testid="nav-dashboard-link"
            >
              Dashboard
            </Link>
          ) : (
            <button
              onClick={onAccess}
              className="flex h-10 items-center rounded-xl border border-[#258DFF]/70 px-3.5 text-[9px] uppercase tracking-[0.16em] text-[#7FC8FF] transition-colors duration-300 hover:bg-[#147DFF] hover:text-white sm:px-4"
              data-testid="nav-login-button"
            >
              Sign In
            </button>
          )}
        </div>
      </div>
    </motion.header>
  );
}
